import { RadioTile, TileGroup, Tooltip } from 'carbon-components-react';
import React, { useEffect } from 'react';
import { QuesIDProps } from '../../Maas360Estimator';
import { segmentsTracking } from 'src/common/lib/tracker';
import { MaaS360 } from 'src/apps/maas360-estimator/constants/default';
import { useSmallBreakpoint } from 'src/common/hooks/widgets/useBreakpoint';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import { convertToString } from 'src/apps/maas360-estimator/lib/utils';

type Step1Props = {
  que1Value: string;
  setQue1Value: React.Dispatch<React.SetStateAction<string>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  setTrackQuesID: React.Dispatch<React.SetStateAction<QuesIDProps>>;
  trackQuesID: QuesIDProps;
  useTranslation: TranslationFunction;
};

const Step1 = ({
  que1Value,
  setQue1Value,
  setIsRequired,
  setTrackQuesID,
  trackQuesID,
  useTranslation,
}: Step1Props) => {
  const isSmall = useSmallBreakpoint('560px');

  useEffect(() => {
    if (que1Value) {
      setIsRequired(false);
    }
  }, []);

  const handleClick = (
    value: string,
    event: React.MouseEvent<HTMLInputElement>,
  ) => {
    setQue1Value(value);
    setIsRequired(false);
    setTrackQuesID({
      ...trackQuesID,
      Q1: (event.target as HTMLInputElement).id,
    });
    segmentsTracking('CTA Clicked', {
      pageTitle: 'MaaS360 Plan Assessment',
      object: 'Mass360 page',
      resultValue: 'CTA clicked',
      CTA: `question 1 - ${value} - selected`,
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  const knowledgeWorker = convertToString(
    useTranslation('que1_text_desc_opt1', true),
  );
  const frontLineDeviceManagement = convertToString(
    useTranslation('messages.que1_text_desc_opt2', true),
  );

  return (
    <div>
      <div className="page_sub_heading padding_8">
        {useTranslation('que1_text_desc')}
      </div>
      <TileGroup
        name="radio-group"
        className="tilegroup"
        valueSelected={que1Value}
      >
        <RadioTile
          className="tile"
          id="Q1A1"
          value={MaaS360.usecase1}
          onClick={(e) => handleClick(knowledgeWorker, e)}
        >
          {useTranslation('que1_text_desc_opt1')}
          <Tooltip
            className="maas360_widget__maas360-tooltip"
            onChange={() => {
              // For segment tracking
              segmentsTracking('CTA Clicked', {
                pageTitle: 'MaaS360 Plan Assessment',
                object: 'Mass360 page',
                resultValue: 'CTA clicked',
                CTA: `question 1 - opt1 knowledge worker - tooltip`,
                location: 'Assessment',
                action: '',
                field: '',
              });
            }}
            direction={isSmall ? 'bottom' : 'right'}
            tabIndex={0}
          >
            <span className="slide_text">
              {useTranslation('que1_text_desc_opt1_tooltip')}
            </span>
          </Tooltip>
        </RadioTile>
        <RadioTile
          className="tile"
          id="Q1A2"
          value={MaaS360.usecase2}
          onClick={(e) => handleClick(frontLineDeviceManagement, e)}
        >
          {useTranslation('que1_text_desc_opt2')}
          <Tooltip
            className="maas360_widget__maas360-tooltip"
            onChange={() => {
              // For segment tracking
              segmentsTracking('CTA Clicked', {
                pageTitle: 'MaaS360 Plan Assessment',
                object: 'Mass360 page',
                resultValue: 'CTA clicked',
                CTA: `question 1 - opt2 frontline devlice management - tooltip`,
                location: 'Assessment',
                action: '',
                field: '',
              });
            }}
            direction={isSmall ? 'bottom' : 'right'}
            tabIndex={0}
          >
            <span className="slide_text">
              {useTranslation('que1_text_desc_opt2_tooltip')}
            </span>
          </Tooltip>
        </RadioTile>
      </TileGroup>
    </div>
  );
};

export default Step1;
